import styled from 'styled-components';

const HighPerformanceEnginesWrapper = styled.div``;

export { HighPerformanceEnginesWrapper };
